import { render, staticRenderFns } from "./report-found-base.vue?vue&type=template&id=e991afb6"
import script from "./report-found-base.vue?vue&type=script&lang=js"
export * from "./report-found-base.vue?vue&type=script&lang=js"
import style0 from "./report-found-base.vue?vue&type=style&index=0&id=e991afb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports